export const CartOrderMixin = {
	data() {
		return {
			shippingCodesMap: {
				takeaway: [
					'takeaway',
					'selfordering-takeaway',
					'selfordering-takeawayextern',
				],
				delivery: [
					'delivery',
					'selfordering-delivery',
				],
				indining: [
					'indining',
					'selfordering-store',
				],
			},
		}
	},
  computed: {
		isDelivery() {
			return this.shippingMethod && this.shippingCodesMap.delivery.includes(this.shippingMethod.code);
		},
		isTakeaway() {
			return this.shippingMethod && this.shippingCodesMap.takeaway.includes(this.shippingMethod.code);
		},
		isIndining() {
			return this.shippingMethod && this.shippingCodesMap.indining.includes(this.shippingMethod.code);
		},
		isOutdoorDelivery() {
			return !!this.cartOutdoorDeliveryPoint;
		},
		co2Locked() {
			return this.orderStates?.co2State == 'locked';
		},
		co2Disabled() {
			return this.orderStates?.co2State == 'disabled';
		},
		timeLocked() {
			return this.orderStates?.timeState == 'locked';
		},
		timeDisabled() {
			return this.orderStates?.timeState == 'disabled';
		},
		tipLocked() {
			return this.orderStates?.tipState == 'locked';
		},
		tipDisabled() {
			return this.orderStates?.tipState == 'disabled';
		},
		paymentLocked() {
			return this.orderStates?.paymentState == 'locked';
		},
		paymentDisabled() {
			return this.orderStates?.paymentState == 'disabled';
		},
		shippingAddressLocked() {
			return this.orderStates?.shippingAddressState == 'locked';
		},
		shippingAddressDisabled() {
			return this.orderStates?.shippingAddressState == 'disabled';
		},
		billingAddressLocked() {
			return this.orderStates?.billingAddressState == 'locked';
		},
		billingAddressDisabled() {
			return this.orderStates?.billingAddressState == 'disabled';
		},
		reusableDishLocked() {
			return this.orderStates?.reusableDishState == 'locked';
		},
		reusableDishDisabled() {
			return this.orderStates?.reusableDishState == 'disabled';
		},
		promotionCouponLocked() {
			return this.orderStates?.promotionCouponState == 'locked';
		},
		promotionCouponDisabled() {
			return this.orderStates?.promotionCouponState == 'disabled';
		},
		dropoffLocked() {
			return this.orderStates?.dropoffState == 'locked';
		},
		dropoffDisabled() {
			return this.orderStates?.dropoffState == 'disabled';
		},
		notesLocked() {
			return this.orderStates?.notesState == 'locked';
		},
		notesDisabled() {
			return this.orderStates?.notesState == 'disabled';
		},
		isAnonymous() {
			return this.orderStates?.isAnonymous;
		},
		isOrderTypeMain() {
			return this.orderType == 'main';
		},
		isOrderTypeTip() {
			return this.orderType == 'tip';
		},
		isOrderTypeReusableDishes() {
			return this.orderType == 'reusable_dishes';
		},
		isOrderTypeCourse() {
			return this.orderType == 'course';
		},
		isOrderTypeVoucher() {
			return this.orderType == 'voucher';
		},
		isOrderTypeVoucherReload() {
			return this.orderType == 'voucher_reload';
		},
		isOrderTypeTip() {
			return this.orderType == 'tip';
		},
		isOrderTypeGastroKurier() {
			return this.orderType == 'gastrokurier';
		},
	},
  methods: {
		shippingMethodIcon(method) {
			const iconMap = [
				{
					icon: 'credit-card',
					methods: [
						'voucher'
					]
				},
				{
					icon: 'users',
					methods: [
						'course'
					]
				},
				{
					icon: 'takeaway',
					methods: [
						...this.shippingCodesMap.takeaway
					]
				},
				{
					icon: 'delivery',
					methods: [
						...this.shippingCodesMap.delivery
					]
				},
				{
					icon: 'indining',
					methods: [
						...this.shippingCodesMap.indining
					]
				}
			];
			return iconMap.find(item => item.methods.includes(method))?.icon || 'info';
		},
		shippingMethodIconComponent(method) {
			return this.iconComponent(this.shippingMethodIcon(method));
		},
  }
};

export default CartOrderMixin;



